/**
 * Ticket: SL-733
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-733
 * Description: Bulk Stock upload popup with download all product csv
 * and upload updated file.
 * Author - Ankit Nigam
 * Date - 26th Feb 2025
 */
import React, { useState } from "react";
import { useAlert } from "react-alert";
import "./BulkStockPopup.css";
import api from "../../seller-apis/api";
import convertCsvFileToJsonArray from "../../utilities/convertFileToJsonArray";
/**
 * Class Used To SHow Bulk Stock upload popup
 * @param {*} param0 
 * @returns 
 */
const BulkStockPopup = ({ isOpen, onClose, refreshAfterBulkUpload }) => {
  const [option, setOption] = useState("download");
  const [isLoading,setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadingMsg,setUploadingMsg] = useState("")
  const [gstErrors, setGstErrors] = useState([])
  const alert = useAlert();
  // Function to handle CSV download
  const handleDownload = () => {
    setLoading(true);
    api.product.exportProductStockSheet().then((res) => {
      //btn.innerHTML = `Export to Sheet <i class="bi bi-file-earmark-spreadsheet"></i>`;
      const url = window.URL.createObjectURL(res.data);
      let link = document.createElement("a");
      link.href = url;
      link.download = "vendor-product-stocks.xlsx";
      link.click();
      setLoading(false);
      onClose();
    }).catch(err => console.log(err))
  };
  //Handle File Change
  const handleFileChange = (e) => {
    setFile(e.target.files);
  };
  // Function to handle CSV file upload
  async function handleFileUpload (){
    if (!file) {
      setUploadingMsg("Please select a file");
      return;
    }
    setLoading(true);
    setUploadingMsg("Uploading...");
    try {
        const mProductStockArray = await convertCsvFileToJsonArray(file);
        bullUploadErrors(mProductStockArray)
        api.product.importProductStockSheet(mProductStockArray)
        .then((res) => {
          setLoading(false);
          setUploadingMsg("")
          setFile(null);
          onClose();
          alert.info(res.message);
          refreshAfterBulkUpload();
        }).catch(err => console.log(err))
    } catch (error) {
      setUploadingMsg("Error uploading file");
    }
  };

const bullUploadErrors = (arr) => {
  let validArr = [];
  let errs = [];
  for (let item of arr) {
    let gst = Number(item["Current GST"]);

    if (gst === 12 || gst === 28) {
      errs.push(
        item["Product Name"] + " not updated as GST should be 0, 5 or 18%"
      );
    } else {
      validArr.push(item);
    }
  }
  setGstErrors(errs);  
  if(errs.length > 0){
    alert.error(errs.length + " products rejected because of gst not being 5,12,or 18%")
  }   
  return validArr; 
};


  if (!isOpen) return null;

  return (
    <div className="bulk-stock-popup-overlay" onClick={onClose}>
      <div className="bulk-stock-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="bulk-stock-popup-close" onClick={onClose}>×</button>
        <h6 style={{display:"flex"}}>Bulk Upload</h6>
        <hr></hr>
        <h6 style={{fontSize:"small",color:"grey",display:"flex", marginTop: "10px"}}>Use My File To</h6>
        {/* Radio Buttons */}
        <div className="bulk-stock-radio-container">
            <label className="bulk-stock-radio-label">
            <input
                type="radio"
                name="option"
                value="download"
                checked={option === "download"}
                onChange={() => setOption("download")}
                disabled={isLoading}
            />
            Download all products
            </label>
            <label className="bulk-stock-radio-label">
            <input
                type="radio"
                name="option"
                value="upload"
                checked={option === "upload"}
                onChange={() => setOption("upload")}
                disabled={isLoading}
            />
            Upload products with updated file
            </label>
        </div>
     
        {/* Fixed height div to prevent resizing */}
        
            {/* Download Button */}
            {option === "download" && (
            <button className="bulk-stock-download-btn" onClick={handleDownload}>Download</button>
            )}
             {/* File Upload Input */}
            {option === "upload" && (
                <>
                <h6 style={{fontSize:"small",color:"black",display:"flex"}}>File To Upload<span style={{color:"red"}}>*</span></h6>
                <input type="file" accept=".xlsx" onChange={(event) => handleFileChange(event)} />
                <button disabled={!file} className={`bulk-stock-download-btn ${!file ? "bulk-stock-download-disabled-btn" : ""}`} onClick={handleFileUpload}>Upload</button>
                </>
            
            )}
          {/*Showing Downloading Label */}
          {isLoading && option === "download" && <p style={{marginTop:"10px",color:"red"}}>Downloading...</p>}
       
          {/*Showing Uploading Label */}
          {option === "upload" && uploadingMsg != "" && <p style={{marginTop:"10px",color:"red"}}>{uploadingMsg}</p>}
       
          {/*SHow Message SL-943 */}
          {option === "upload" && <p style={{marginTop:"10px",color:"red"}}>Price updates skipped for pending approvals,<br/> other updates applied.</p>}
       
      </div>
    </div>
  );
};

export default BulkStockPopup;
